<template>
  <table class="table">
    <thead>
      <tr class="title p-1 w-full">
        <th>{{ title }}</th>
      </tr>
    </thead>
    <div class="bodyTable flex flex-wrap">
      <div
        class="w-1/3 no-page-break p-2"
        v-for="(foto, index) in imgs"
        :key="index"
      >
        <vs-card class="">
          <div>
            <p>
              {{ foto.legenda ? foto.legenda : foto.nome }}
            </p>
            <p>
              {{ formataData(foto.updatedAt, 'withHour') }}
            </p>
            <p>
              {{ foto.nomeUsuario }}
            </p>
          </div>
          <div>
            <!-- PDF -->
            <a
              v-if="isPdf(foto.nome)"
              class="flex justify-center"
              :href="foto.nome"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="w-1/2"
                src="../../../../../assets/images/elements/PDF_file_icon2.png"
              />
            </a>

            <!-- Imagem -->
            <img v-else class="w-full" :src="foto.nome" /></div
        ></vs-card>
      </div>
    </div>
  </table>
</template>

<script>
import dayjs from 'dayjs';
export default {
  props: {
    title: {
      type: String,
    },
    imgs: {
      type: Array,
    },
  },
  methods: {
    /**
     * Formats a given date into a specific format.
     * @param {Date|string} data The date to be formatted.
     * @param {string} [extraParams=''] Additional parameters to determine the format. Possible value: 'withHour'.
     * @returns {string} The formatted date string.
     */
    formataData(data, extraParams = '') {
      if (!data) {
        return '';
      }
      const formato =
        extraParams === 'withHour' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY';
      const dataFormatada = dayjs(data).format(formato);
      return dataFormatada;
    },

    /**
     * Checks if a given URL represents a PDF file.
     * @param {string} urlArquivo The URL of the file to check.
     * @returns {boolean} True if the file is a PDF, otherwise false.
     */
    isPdf(urlArquivo) {
      const ext = urlArquivo.split('.').pop();
      const isPdfFile = ext === 'pdf';
      return isPdfFile;
    },
  },
};
</script>

<style scoped>
@media print {
  thead {
    display: table-header-group;
  }
  .no-page-break {
    page-break-inside: avoid;
  }
}
</style>
